module.exports = __webpack_public_path__ + "media/images/defaultother-811b9a66.png";